import axios, { AxiosInstance } from "axios";

type ApiClientOptions = {
  timeout?: number;
};

export default function ApiClient(options?: ApiClientOptions): AxiosInstance {
  const apiBaseUrl = localStorage.getItem("tenantUrl");
  const apiKey = localStorage.getItem("tenantKey");
  const opId = localStorage.getItem("opId");

  if (!apiBaseUrl || !apiKey) {
    throw new Error("ApiClient: Missing tenantUrl or tenantKey");
  }

  const client = axios.create({
    baseURL: apiBaseUrl,
    headers: {
      uiod: apiKey,
      ...(opId ? { opId } : {}),
    },
    ...options,
  });

  return client;
}
